"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wixColorParam = exports.getWixColor = void 0;
var parseColor = require("color");
var withWixRequired_1 = require("./withWixRequired");
function getWixColor(Wix, reference, opacity) {
    if (opacity === void 0) { opacity = 1; }
    withWixRequired_1.withWixRequired(Wix);
    var wixColor = Wix.Styles.getSiteColors(function () { }).find(function (c) { return c.reference === reference; });
    var parsedColor = parseColor(wixColor.value);
    return {
        opacity: opacity,
        value: parsedColor
            .rgb()
            .alpha(opacity)
            .string(),
        name: wixColor.name,
    };
}
exports.getWixColor = getWixColor;
exports.wixColorParam = function (name, opacity) { return function (_a) {
    var Wix = _a.Wix;
    return getWixColor(Wix, name, opacity);
}; };
//# sourceMappingURL=getWixColor.js.map